"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _useInsertUser = _interopRequireDefault(require("./hooks/useInsertUser"));

var _useSetDeepDive = _interopRequireDefault(require("./hooks/useSetDeepDive"));

var _usePchLookup = _interopRequireDefault(require("./hooks/usePchLookup"));

var _useHitStreet = _interopRequireDefault(require("./hooks/useHitStreet"));

var _useGeoLookup = _interopRequireDefault(require("./hooks/useGeoLookup"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var useSetNewSession = function useSetNewSession(props) {
  var tracking = props.tracking,
      dispatchTracking = props.dispatchTracking,
      dispatchApp = props.dispatchApp,
      setLoading = props.setLoading,
      animationComplete = props.animationComplete;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      shouldExecute = _useState2[0],
      setShouldExecutePost = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = _slicedToArray(_useState3, 2),
      userContext = _useState4[0],
      setUserContext = _useState4[1];

  var _useState5 = (0, _react.useState)(null),
      _useState6 = _slicedToArray(_useState5, 2),
      redirectTo = _useState6[0],
      setRedirection = _useState6[1];

  var topProps = {
    hsid: Number(tracking.HSID),
    pid: Number(tracking.PID),
    sid: Number(tracking.SID),
    oid: Number(tracking.OID),
    uid: tracking.UID,
    eid: tracking.EID
  };
  var hsid = (0, _useHitStreet.default)(topProps);
  var ip_address = (0, _useGeoLookup.default)(dispatchTracking);
  (0, _useInsertUser.default)(topProps, hsid, ip_address, shouldExecute);
  var pchComplete = (0, _usePchLookup.default)(tracking['PT1'], tracking['PT2'], hsid, dispatchTracking);
  var redirect = (0, _useSetDeepDive.default)(tracking['VERTICAL'], tracking['TYPE'], dispatchApp);

  var setNewUserContext = function setNewUserContext() {
    var payload = _objectSpread({}, topProps, {
      hsid: hsid,
      se: tracking.SE,
      kwd: tracking.KWD,
      pacid: tracking.PACID,
      pt1: tracking.PT1,
      pt2: tracking.PT2,
      gclid: tracking.GCLID,
      email: tracking.EMAIL
    });

    dispatchTracking({
      type: 'USER_ARRIVED',
      payload: payload
    });
    setUserContext(payload);
  }; // Final step check before returning user to page


  (0, _react.useEffect)(function () {
    if (animationComplete && pchComplete && shouldExecute) {
      if (redirect) {
        // Wait until now to set the redirect variable because it triggers route change
        setRedirection(redirect);
      }

      ;
      setLoading(false);
    }

    ; // eslint-disable-next-line
  }, [animationComplete, redirect, pchComplete, shouldExecute]); // Once we have the hsid from hitstreet, set the user tracking context

  (0, _react.useEffect)(function () {
    if (hsid && !userContext) {
      setNewUserContext();
    }

    ; // eslint-disable-next-line
  }, [hsid, userContext]); // Once we have the ip_address(even if it is 'N/A'), and the hsid from hitstreet, post them to Mongo.

  (0, _react.useEffect)(function () {
    if (ip_address && userContext) {
      setShouldExecutePost(true);
    }

    ; // eslint-disable-next-line
  }, [ip_address, userContext]);
  return redirectTo;
};

var _default = useSetNewSession;
exports.default = _default;

//# sourceMappingURL=useSetNewSession.jsx.map